import {
    FETCH_QUESTIONS_REQUEST,
    FETCH_QUESTIONS_SUCCESS,
    FETCH_QUESTIONS_FAILURE,
    UPDATE_QUESTIONS_REQUEST,
    UPDATE_QUESTIONS_SUCCESS,
    DELETE_ALL_QUESTION_REQUEST,
    ADD_ANSWER_REQUEST,
    ADD_ANSWER_SUCCESS,
    UPDATE_ANSWER_REQUEST,
    UPDATE_ANSWER_SUCCESS,
    QUESTIONS_EXPORT_REQUEST,
} from "../actions/questionsActions";

const initialState = {
    loading: false,
    questions: [],
    error: "",
    updateSuccess: false,
};

const questionsReducer = (state = initialState, action) => {
    switch (action.type) {
    case FETCH_QUESTIONS_REQUEST:
        return { ...state, loading: true, updating: false };
    case FETCH_QUESTIONS_SUCCESS:
        return {
            ...state,
            loading: false,
            updating: false,
            questions: action.payload,
            error: "",
        };
    case FETCH_QUESTIONS_FAILURE:
        return {
            ...state,
            loading: false,
            updating: false,
            questions: [],
            error: action.payload,
        };
    case UPDATE_QUESTIONS_REQUEST:
        return {
            ...state,
            ...action.payload,
            loading: false,
            updating: true,
        };
    case UPDATE_QUESTIONS_SUCCESS:
        return {
            ...state,
            ...action.payload,
            loading: false,
            updating: false,
            updateSuccess: true,
        };
    case ADD_ANSWER_REQUEST:
        return {
            ...state,
            ...action.payload,
            loading: false,
            updating: true,
        };
    case ADD_ANSWER_SUCCESS:
        return {
            ...state,
            ...action.payload,
            loading: false,
            updating: false,
            updateSuccess: true,
        };
    case UPDATE_ANSWER_REQUEST:
        return {
            ...state,
            ...action.payload,
            loading: false,
            updating: true,
        };
    case UPDATE_ANSWER_SUCCESS:
        return {
            ...state,
            ...action.payload,
            loading: false,
            updating: false,
            updateSuccess: true,
        };
    case DELETE_ALL_QUESTION_REQUEST:
        return { ...state, loading: false };
    case QUESTIONS_EXPORT_REQUEST:
        return { ...state, loading: false };
    default:
        return state;
    }
};

export default questionsReducer;
